import {Card, CardContent, Grid} from '@material-ui/core';
import {Formik, FormikHelpers, FormikProps} from 'formik';
import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {Merchant} from '../../../shared/model/Merchant.model';
import {SettlementInstitution} from '../../../shared/model/SettlementInstitution.model';
import {TransHelper} from '../../../utils/trans-helper';
import NxButton from '../../shared/nxButton/NxButton';
import {NxFormikInput} from '../../shared/nxInput/NxFormikInput';
import {NxFormikSelect} from '../../shared/nxSelect/NxFormikSelect';
import {NxSelectOption} from '../../shared/nxSelect/NxSelect';
import {SettlementFormFields, settlementInitForm, settlementValidationSchema} from './SettlementSettings.model';
import styles from './SettlementSettings.module.scss';

export type SettlementProps = {
  merchant: Merchant;
  submitSettlements: (
    values: SettlementFormFields,
    actions: FormikHelpers<SettlementFormFields>
  ) => Promise<void>,
  institutions: Array<SettlementInstitution>;
};

export const MERCHANT_ERROR_KEY = 'merchant_error';
export const PrefixTrans = TransHelper.getPrefixedTrans('SETTINGS.SETTLEMENT');

export default function SettlementSettings({
  merchant,
  submitSettlements,
  institutions
}: SettlementProps): React.ReactElement {

  const {t} = useTranslation();

  const getBankOptions = (): NxSelectOption[] => institutions.map(institution => ({
    label: institution.name,
    value: institution.code
  } as NxSelectOption));

  return (
    <Formik
      enableReinitialize={true}
      initialValues={settlementInitForm(merchant)}
      onSubmit={submitSettlements}
      validateOnMount={false}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={settlementValidationSchema(t)}>
      {
        (
          {handleSubmit, errors, isSubmitting}: FormikProps<SettlementFormFields>): ReactElement => (
          <form onSubmit={handleSubmit}>
            <Grid container className={styles.root}>
              <Grid item xs={6} className={styles.item}>
                <Card classes={{root: styles.card}} variant='outlined'>
                  <CardContent classes={{root: styles.cardContent}}>
                    <div className={styles.title}>
                      <PrefixTrans>TITLE</PrefixTrans>
                    </div>
                    <NxFormikSelect
                      options={getBankOptions()}
                      name={'institutionCode'}
                      label={<PrefixTrans>BANK_CODE</PrefixTrans>} />
                    <NxFormikInput
                      className={styles.input}
                      name={'accountNo'}
                      label={<PrefixTrans>ACCOUNT_NUMBER</PrefixTrans>} />
                    <NxFormikInput
                      className={styles.input}
                      name={'recipientName'}
                      label={<PrefixTrans>RECIPIENT</PrefixTrans>} />
                    <NxFormikInput
                      className={styles.input}
                      name={'recipientAddress'}
                      label={<PrefixTrans>ADDRESS</PrefixTrans>} />
                    <div className={styles.error}>{errors[MERCHANT_ERROR_KEY]}</div>
                  </CardContent>
                </Card>
              </Grid>
              {/* TODO */}
              {/* <Grid item xs={4} className={styles.item}>
                    <div className={styles.settingsRules}>
                      <Typography variant='h4'
                                  component='h4'
                                  className={styles.settingsRulesTitle}>
                        <PrefixTrans>SETTLEMENT_RULES</PrefixTrans>
                      </Typography>
                      <p>
                        Model the construction of an explanation. Users should be
                        given the opportunity to identify the phenomenon, the
                        sequenced explanation and underline the concluding
                        statement.
                      </p>
                      <ul>
                        <li>Bullet point</li>
                        <li>Bullet point 2</li>
                      </ul>
                    </div>
                  </Grid> */}
            </Grid>
            <div className={styles.submitRow}>
              <NxButton className={styles.button} loaded={!isSubmitting} type='submit'>
                <PrefixTrans>SUBMIT_LABEL</PrefixTrans>
              </NxButton>
            </div>
          </form>
        )
      }
    </Formik>
  );
}